import {
  EntityReportsList,
  type EntityReportsListProps,
} from "@/components/reports/EntityReportsList";

export type PortfolioReportsProps = EntityReportsListProps;

export const PortfolioReports: React.FC<PortfolioReportsProps> = (props) => (
  <EntityReportsList entityType="portfolio" {...props} />
);
